module.exports = __webpack_public_path__ + "img/home_schoolfour.6392ae79.svg";